import { UiButton, UiIcon, UiText } from 'znanie-uikit';
import { useReactiveVar } from '@apollo/client';

import { IRegistrationProps } from '../index';
import { EventTimer } from '../EventTimer';

import { eventRegisterBtnStateVar } from 'store/eventRegisterBtnState';

import { useBroadcastsStatus } from 'hooks/utils/useBroadcastsStatus';

import css from './OnlineEventRegistration.module.scss';

interface IProps
  extends Pick<
    IRegistrationProps,
    | 'eventId'
    | 'isUserRegistered'
    | 'broadcasts'
    | 'startDate'
    | 'onSignUpClick'
    | 'onCancel'
  > {
  isEventStarted: boolean;
}

export default function OnlineEventRegistration({
  eventId,
  isUserRegistered,
  broadcasts,
  startDate,
  isEventStarted,
  onSignUpClick,
  onCancel,
}: IProps) {
  const { isDisabled } = useReactiveVar(eventRegisterBtnStateVar);

  const { currentBroadcast, futureBroadcast } = useBroadcastsStatus(broadcasts);

  return (
    <>
      {/* отображаем данный стейт, если пользователь не зарегистирован на мероприятие,
       и мероприятие еще не началось, либо не началась следующая трансляция*/}
      {!isUserRegistered && !currentBroadcast && (
        <div className={css.stateBlock}>
          <UiText className={css.onlineInfo} align="center">
            Запишитесь на мероприятие, чтобы присоединиться{' '}
            <span className={css.onlineInfo}>
              к онлайн трансляции и добавить мероприятие в календарь.
            </span>
          </UiText>
          <UiButton
            className={css.onlineOutlineRegisterBtn}
            fluid
            variant="primary"
            weight="normal"
            disabled={isDisabled}
            onClick={onSignUpClick}
          >
            Записаться
          </UiButton>
        </div>
      )}

      {/* отображаем данный стейт, если пользователь зарегистирован на мероприятие,
       и мероприятие еще не началось, либо не началась следующая трансляция*/}
      {isUserRegistered && (!isEventStarted || !currentBroadcast) && (
        <div className={css.stateBlock}>
          {/* отображаем таймер до начала мероприятия или если есть следующая трансляция*/}
          {(!isEventStarted || futureBroadcast) && (
            <EventTimer value={futureBroadcast?.startTime || startDate} />
          )}
          <div className={css.onlineInfoWrapper}>
            <UiIcon name="check-mark-circle" color="#53BA05" />
            <UiText className={css.onlineInfo}>
              Вы записаны на мероприятие
            </UiText>
          </div>
          <UiButton
            fluid
            variant="standard"
            weight="normal"
            disabled={isDisabled}
            onClick={onCancel}
          >
            Отменить запись
          </UiButton>

          <UiButton
            fluid
            startIcon={<UiIcon name="calendar" size={18} />}
            weight="normal"
            variant="outline"
            href={`${process.env.NEXT_PUBLIC_API_HOST}/api/event-calendar/${eventId}/cal.ics`}
            target="_blank"
          >
            Добавить в календарь
          </UiButton>
        </div>
      )}
    </>
  );
}
